<template>
  <div>

    <HeaderBreadcrumbs :items="[
      { label: 'Category', to: { name: 'category' } },
      { label: 'Add New' },
    ]" title="New Category" />

    <div class="bg-white w-full rounded-lg my-3 px-4 py-2.5">
      <h4 class="font-bold text-xl py-2.5">Create New Category</h4>
      <div class="w-1/2 flex-col">
        <div>
          <label class="block">Category Name</label>
          <input type="text" class="px-4 py-2.5 border font-medium text-gray-500 text-sm rounded-lg w-full"
           :class="[
              submitted && !name ? 'bg-red-300 focus:ring-red-500 border-red-500 placeholder-red-500' : 'border-gray-300 bg-gray-50 '
            ]" 
            id="name" placeholder="Enter Display Name" v-model="name" />
              <p v-if="submitted && !name" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-2">
          <label class="block">Content’s Type</label>
          <SelectType 
           :isError="validateItemType"
            class="text-gray-500 font-medium" v-model="item_type" :options="options"
            :defaultText="'Select Content’s Type'" />
             <p v-if="submitted && !item_type" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-2 mr-2">
          <label class="block">Category BISAC</label>
          <multiselect v-model="category_bisac" label="name" track-by="code" placeholder="Select Category BISAC"
          class="custom-multiselect text-gray-500 text-sm"
           :class="{ 'error': submitted && !category_bisac }"
            open-direction="bottom" :options="items_category_bisac" :searchable="true"
            :loading="isLoadingSearch" :close-on-select="true" @search-change="asyncFind">
            <span slot="noResult">
              Oops! No elements found. Consider changing the search query.
            </span>
            <template #option="{ option }">
              <div class="text-sm ">
                {{ option.name }}
              </div>
            </template>
             <template #singleLabel="{ option }">
            <div class="text-sm font-medium text-gray-500 px-2">
              {{ option.name }}
            </div>
            </template>
            <template #caret>
              <svg class="w-5 h-5 text-gray-500 absolute right-5 top-2.5" fill="none" stroke="currentColor"
                stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </template>
          </multiselect>
             <p v-if="submitted && !category_bisac" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-2 mr-2">
          <label class="block"> Category AX</label>
          <multiselect v-model="category_ax" label="name" track-by="code" class="custom-multiselect"
            :class="{ 'error': submitted && !category_ax }"
            placeholder="Select Category AX" open-direction="bottom" :options="axSearchOptions" :searchable="true"
            :loading="isAxSearch" :close-on-select="true" :multiple="false" @search-change="axFind">
            <template #option="{ option }">
              <div class="text-sm">
                {{ option.name }}
              </div>
            </template>
             <template #singleLabel="{ option }">
            <div class="text-sm font-medium text-gray-500">
              {{ option.name }}
            </div>
            </template>
            <template #caret>
              <svg class="w-5 h-5 text-gray-500 absolute right-5 top-2.5" fill="none" stroke="currentColor"
                stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </template>
          </multiselect>
            <p v-if="submitted && !category_ax" class="text-red-500 text-sm mt-1 mb-0">Must be filled.</p>
        </div>
        <div class="mt-3 mb-4">
          <t-checkbox type="checkbox" id="is_active" v-model="is_active" />
          <label class="form-check-label" for="is_active">Active</label>
        </div>

        <div class="flex justify-start pb-3">
          <button class="bg-blue-700 text-white rounded-lg px-3 py-2" @click="addCategory">Save</button>
          <button class="bg-white text-gray-500 rounded-lg border px-3 py-2 ml-4" @click="cancel">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import constant from '../../store/constant';
import { EventBus } from '../../event-bus';
import SelectType from '../../components/form/ContentTypeSelector.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';

const itemType = Object.entries(constant.ITEM_TYPES).map((val) => ({
  text: val[1],
  value: val[1].toLowerCase(),
}));
export default {
  name: 'AddCategory',
  components: {
    HeaderBreadcrumbs,
    SelectType
  },
  data() {
    return {
      name: '',
      is_active: false,
      items_category_bisac: [],
      category_bisac: null,
      category_ax: null,
      submitted:false,
      validateItemType:false,
      axSearchOptions: [],
      isAxSearch: false,
      isLoadingSearch: false,
      item_type: null,
      options: [
        ...itemType,
      ],
    };
  },
  computed: {
    ...mapState({
      successMessage: (state) => state.category.successMessage,
      errorMessage: (state) => state.category.errorMessage,
    }),
  },
  watch: {
    successMessage: function () {
      if (!this.successMessage) return;
      EventBus.$emit('show-toast', {
        message: 'New category has been added.',
        type: 'success',
      });
      this.$router.push('/category');
    },
    errorMessage: function () {
      if (!this.errorMessage) return;
      EventBus.$emit('show-toast', {
        message: this.errorMessage,
        type: 'error',
      });
    },
      'item_type'() {
      this.validateItemType = false
    },
  },
  methods: {
    ...mapActions('category', ['createCategory']),
    ...mapActions('category_bisac', ['searchCategoryBisac']),
    ...mapActions('ax', ['searchCategoryAx']),

    async addCategory() {
      this.submitted = true;
      
      const isContentInvalid = this.item_type === null
      if (isContentInvalid) {
        this.validateItemType = true
      }

     if (!this.name || !this.category_ax || !this.category_bisac || isContentInvalid) {
        return;
    }

      const payload = {
        name: this.name,
        item_type: this.item_type,
        is_active: this.is_active,
        category_bisac: this.category_bisac.id,
        category_ax: this.category_ax.id
      };
      this.createCategory(payload);
    },
    asyncFind(keyword) {
      if (!keyword) return;
      this.isLoadingSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          search: keyword,
        };

        this.searchCategoryBisac(payload)
          .then((response) => {
            this.items_category_bisac = response.data.data;
            this.isLoadingSearch = false;
          })
          .catch(() => {
            this.isLoadingSearch = false;
          });
      }, 600);
    },
    axFind(query) {
      if (!query) return;

      this.isAxSearch = true;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        let payload = {
          q: query,
          limit: 10,
        };
        this.searchCategoryAx(payload).then((response) => {
          this.axSearchOptions = response.data.data.rows;
          this.isAxSearch = false;
        }).catch(() => {
          this.isAxSearch = false;
        });
      }, 600);
    },

    cancel() {
      this.$router.push('/category');
    }
  },
};
</script>
